const STORAGE_KEY = 'aisym_demo_lead'

export type DemoLead = {
  nome: string
  email: string
}

// TODO(comercial): trocar pelo número real do WhatsApp do time comercial.
export const COMERCIAL_WHATSAPP_LINK = 'https://wa.me/5500000000000'

export const getDemoLead = (): DemoLead | null => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    return raw ? (JSON.parse(raw) as DemoLead) : null
  } catch {
    return null
  }
}

export const saveDemoLead = (lead: DemoLead) => {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(lead))
}
